import React from 'react';
import PropTypes from 'prop-types';
import {deleteIcon }from '../../../assets'
import { getAppOverViewDetails, removebannerApi, saveconfigurationsApi } from '../../dev_services/developer/api';
import { fetchDataSuccess } from '../../dev_store/slice/apps_overview_slice/apps_overview_slice';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

export default function DevImageList({ banners }) {
  const { appID } = useParams();
  const dispatch = useDispatch();
  const handleDelete = async (title, url) => {
  
    try{
     // Assuming 'response' contains the app_icon object with the app_id property
     const sendData = {
      remove_banner: [
          title,
          
      ]
  };

      
      ///save image on s3 bucket server
      const saveResponse = await removebannerApi(appID,sendData);
      console.log(saveResponse)
      ///fect new update changes
      const responseUpdate = await getAppOverViewDetails(appID);
      const slugName = responseUpdate.slug;
      localStorage.setItem('slug', slugName);
      dispatch(fetchDataSuccess(responseUpdate));
  
     }
     catch(error:any){
      toast.error(error);
     }

  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px',  }}>
      {banners.map((banner, index) => (
        <div key={index} style={{ position: 'relative', width: 'calc(25% - 20px)',}}>
          <div style={{ position: 'relative' }}>
            <img src={banner.url} alt={banner.title} style={{ maxWidth: '100%', maxHeight: '200px', marginBottom: '10px' }} />
            <div style={{ position: 'absolute', top: '5px', right: '5px', borderRadius: '50%', backgroundColor: 'white', padding: '5px' }}>
              <img
                style={{ width: '20px', cursor: 'pointer' }}
                src={deleteIcon}
                alt="Close Icon"
                onClick={() => handleDelete(banner.title, banner.url)}
              />
            </div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <h3>{banner.title}</h3>
          </div>
        </div>
      ))}
    </div>
  );
  
}

DevImageList.propTypes = {
  banners: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  ).isRequired
};
